import { LayersIcon, SparklesIcon, Trash2Icon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useModelProviders } from '@/features/admin/model/useModelProviders';
import { useWhitelistedProviders } from '@/features/admin/model/useWhitelistedProviders';
import {
  ProviderWhitelistCard,
  ProviderWhitelistCardSkeleton,
} from '@/features/admin/ui/ProviderWhitelistCard';
import {
  WorkspaceProviderWhitelistRules,
  WorkspaceProviderWhitelistRulesSkeleton,
} from '@/features/admin/ui/WorkspaceProviderWhitelistRules';
import { AdminPageShell } from '../AdminPageShell';

export const ModelProvidersPage = () => {
  const { t } = useTranslation('admin');
  const { data: allProviders = [], isLoading: isLoadingProviders } = useModelProviders();
  const { data: whitelistedProviders = [], isLoading: isLoadingWhitelist } =
    useWhitelistedProviders();

  const isLoading = isLoadingProviders || isLoadingWhitelist;

  // The page has never named itself: the tab layout it was built for headed
  // every tab "Tools configuration", so the redesigned header is the first
  // place it needs a name of its own.
  return (
    <AdminPageShell
      title={t('admin.adminLayout.aiModels')}
      about={{
        title: t('admin.modelProvidersPage.about.title'),
        description: t('admin.modelProvidersPage.about.description'),
        rows: [
          {
            icon: SparklesIcon,
            text: t('admin.modelProvidersPage.about.enabledProvidersEverywhere'),
          },
          { icon: LayersIcon, text: t('admin.modelProvidersPage.about.workspaceRulesRestrict') },
          { icon: Trash2Icon, text: t('admin.modelProvidersPage.about.removingDeletesRules') },
        ],
      }}
    >
      {isLoading ? (
        <div data-testid="ai-models-loading" className="flex w-full flex-col gap-8" aria-busy>
          <ProviderWhitelistCardSkeleton />
          <WorkspaceProviderWhitelistRulesSkeleton />
        </div>
      ) : (
        <div className="flex w-full flex-col gap-8">
          <ProviderWhitelistCard
            whitelistedProviders={whitelistedProviders}
            allProviders={allProviders}
          />

          <WorkspaceProviderWhitelistRules whitelistedProviders={whitelistedProviders} />
        </div>
      )}
    </AdminPageShell>
  );
};
